import React from 'react';
import { Badge } from './ui/badge';
import { Loader2, CheckCircle2, XCircle, Clock, AlertTriangle, Ban } from 'lucide-react';

const STATUS_CONFIG = {
  pending: { label: 'En attente', variant: 'secondary', icon: Clock, className: 'text-muted-foreground' },
  running: { label: 'En cours', variant: 'default', icon: Loader2, className: 'text-blue-400 animate-spin' },
  completed: { label: 'Terminé', variant: 'default', icon: CheckCircle2, className: 'text-emerald-400' },
  failed: { label: 'Échoué', variant: 'destructive', icon: XCircle, className: 'text-red-400' },
  cancelled: { label: 'Annulé', variant: 'secondary', icon: Ban, className: 'text-muted-foreground' },
  awaiting_validation: { label: 'Validation requise', variant: 'default', icon: AlertTriangle, className: 'text-amber-400' },
  retrying: { label: 'Nouvelle tentative', variant: 'default', icon: Loader2, className: 'text-amber-400 animate-spin' },
};

export default function StatusBadge({ status, showIcon = true, size = 'default' }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  const sizeClasses = size === 'sm' ? 'text-xs px-1.5 py-0' : '';

  return (
    <Badge variant={config.variant} className={`gap-1 font-medium ${sizeClasses}`}>
      {showIcon && <Icon className={`w-3 h-3 ${config.className}`} />}
      {config.label}
    </Badge>
  );
}
